<template>
  <van-popup class="qrcodePopup" v-model="show" position="bottom" :style="{ height: '100%' }">
    <div class="content">
      <img class="qrCodePic" :class="{ pointerEventsNone: getIsApp }" :src="getQrcodePopup.qrCodeSrc" id="qrCodePic" />
      <div class="bottomPart">
        <template v-if="!getIsApp">
          <div class="tipBox">
            <div class="label">长按保存图片</div>
            <div class="tip">打开{{ PLATFORM_TYPE_DETAIL[getQrcodePopup.platformType].collectively }}扫一扫，选择相册图片，即可<br />找到对应商品</div>
          </div>
        </template>
        <template v-else>
          <div class="cancelBtn" @click="save">保存图片</div>
          <div class="cancelBtn" @click="scan">识别并跳转</div>
        </template>
        <div class="cancelBtn" @click="close">取消</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup, Image as VanImage } from 'vant'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'SouhuoH5Qrcodepopup',

  components: {
    'van-popup': Popup,
    'van-image': VanImage
  },

  data() {
    return {
      show: false,
      pressTimer: null
    }
  },

  watch: {
    getQrcodePopup: {
      handler(val) {
        this.show = val.isShow
      },
      deep: true,
      immediate: true
    }
  },

  computed: {
    ...mapGetters(['getQrcodePopup', 'getIsApp'])
  },

  mounted() {},

  methods: {
    ...mapMutations(['SET_QRCODE_POPUP']),
    close() {
      this.SET_QRCODE_POPUP({
        ...this.getQrcodePopup,
        isShow: false
      })
    },
    scan() {
      const { qrCodeSrc, platformType } = this.getQrcodePopup
      this.$uni.postMessage({
        data: {
          scanQrCodePic: true,
          qrCodeSrc,
          platformType
        }
      })
    },
    save() {
      const { qrCodeSrc: imageUrl } = this.getQrcodePopup
      this.$uni.postMessage({
        data: {
          saveImageToPhotosAlbumHandler: true,
          imageUrl
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.qrcodePopup {
  background-color: transparent;
  font-size: 14px;
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    .qrCodePic {
      display: block;
      position: static;
      width: auto;
      max-width: 90%;
      flex: 1;
      margin: 30px 0;
      border-radius: 10px;
      overflow: hidden;
      pointer-events: auto;
      object-fit: contain;
      &.pointerEventsNone {
        pointer-events: none;
      }
    }
    .bottomPart {
      width: 100%;
      background-color: #f2f2f2;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      .tipBox {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px;
        .label {
          font-weight: 700;
          margin-bottom: 10px;
        }
        .tip {
          text-align: center;
          color: rgb(124, 123, 123);
        }
      }
      .cancelBtn {
        display: flex;
        align-items: center;
        justify-content: space-around;
        background-color: #fff;
        height: 50px;
        border-bottom: 1px solid #f2f2f2;
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
